const errorInput = {
    errorEmpty: "CIF Number is required",
    errorSpace: "CIF Number must not contain any space",
    errorChar: "CIF must be numbers only",
    errorLength: "CIF Number must be 11 digits"
}

export {
    errorInput
}